import React from 'react';
import styled from 'astroturf/react';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import routes from 'js/core_pre_webpack/routes';
import $image_url from 'js/utils/image_url';
import { Button } from '../shared/SignUpButton';

const Container = styled.div`
  padding: 52px calc(max(16px, (100% - 1130px) / 2)) 0 0;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  column-gap: 72px;
  background: #f8f8fb;

  @media screen and (max-width: 767px) {
    padding: 32px 16px;
  }
`;

const Image = styled.img`
  max-width: 50%;
  object-fit: cover;
  object-position: right;
  height: 435px;

  @media screen and (max-width: 767px) {
    display: none;
  }

  @media screen and (max-width: 991px) {
    height: 258px;
  }
`;

const FooterContainer = styled.div`
  max-width: 680px;
`;

const Sentence = styled.div`
  color: #222233;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 24px;

  @media screen and (max-width: 767px) {
    margin: 0 48px 24px;
  }

  @media screen and (min-width: 768px) {
    font-size: 32px;
    line-height: 44px;
    margin-bottom: 32px;
  }

  @media screen and (min-width: 992px) {
    font-size: 44px;
    line-height: 56px;
    letter-spacing: -0.015em;
  }
`;

const BottomSection: React.FunctionComponent = () => {
  const discoveryPage = routes.courses_url();
  return (
    <Container>
      <FooterContainer>
        <Sentence>
          Not finding what you’re looking for? View all of our Courses
        </Sentence>
        <a href={discoveryPage}>
          <Button>
            View All Academia Courses
            <i>
              <FontAwesomeIcon icon={faCaretRight} />
            </i>
          </Button>
        </a>
      </FooterContainer>
      <Image src={$image_url('courses/cloud-lady.png')} />
    </Container>
  );
};

export default BottomSection;
